import axios from "axios";

const URL_USUARIO_V2 = "/usuarios/api/v2/usuarios";
const URI_FAZENDA = "/fazendas/api/v1/fazendas";

class BenchmarkService {
  async obtemAcessoUsuarioAoBenchmark(email) {
    const response = await axios.get(
      `${URL_USUARIO_V2}/acesso-benchmark/${encodeURIComponent(email)}`,
    );
    return response.data;
  }

  async gerenciarAcessoBenchmark(email, body) {
    return axios.put(
      `${URL_USUARIO_V2}/acesso-benchmark/${encodeURIComponent(email)}`,
      body,
    );
  }

  async obtemAcessoFazendasClienteBenchmark(nomeCliente, nomeFazendas) {
    const response = await axios.get(
      `${URI_FAZENDA}/benchmark/acesso/cliente/${encodeURIComponent(nomeCliente)}`,
      { params: { nomeFazendas } },
    );
    return response.data;
  }
}

export default new BenchmarkService();
